import * as React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';

const CustomDialogTitle = (props) => {
    return <DialogTitle {...props} />;
};

export { CustomDialogTitle as DialogTitle };
